import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
export function ProductInfo() {
  return <section className="mb-16" data-id="element-113">
      <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-114">How It Works</h2>
      <div className="text-lg mb-6" data-id="element-115">
        <p className="mb-4" data-id="element-116">
          Unlike $800 purifier towers, Petssey DNRx uses a natural process called
          <strong data-id="element-117">Negative Ion Air Technology™</strong>, the same principle that 
          makes the air feel so clean after a thunderstorm or near a waterfall.
        </p>
        <p className="mb-4" data-id="element-118">
        Here's what happens when you plug it in:
        </p>
        <ul className="space-y-3 mb-6" data-id="element-119">
          <li className="flex items-center" data-id="element-120">
            <CheckIcon className="text-green-500 mr-2" size={24} data-id="element-121" />
            <span data-id="element-122"><strong data-id="element-123">Releases safe negative ions 24/7</strong> into the air</span>
          </li>
          <li className="flex items-center" data-id="element-124">
            <CheckIcon className="text-green-500 mr-2" size={24} data-id="element-125" />
            <span data-id="element-126">These ions attach to microscopic Fel d1 cat dander particles — 
            the same ones HEPA filters often miss.</span>
          </li>
          <li className="flex items-center" data-id="element-127">
            <CheckIcon className="text-green-500 mr-2" size={24} data-id="element-128" />
            <span data-id="element-129">
              The particles clump together into heavier clusters and fall harmlessly out of the air you breathe.
            </span>
          </li>
          <li className="flex items-center" data-id="element-130">
            <CheckIcon className="text-green-500 mr-2" size={24} data-id="element-131" />
            <span data-id="element-132">
              A discreet{' '}
              <strong data-id="element-133"> carbon layer</strong> reduces lingering dander and odours{' '}
            </span>
          </li>
          <li className="flex items-center" data-id="element-134">
            <CheckIcon className="text-green-500 mr-2" size={24} data-id="element-135" />
            <span data-id="element-136">
              {' '}
              Certified ozone-safe [8], whisper-quiet, and completely filter-free
            </span>
          </li>
        </ul>
        <p className="italic mb-8" data-id="element-137">
          It's like installing “gravity for allergens” right into your wall socket.
        </p>
        <p className="mb-8" data-id="element-138">
        And unlike other ionisers of the past, <strong data-id="element-139">Petssey DNRx has been safety-certified</strong>
         to run continuously in any room — even around children and pets.
        </p>
      </div>
      <div className="flex justify-center mb-8" data-id="element-140">
        <img src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExYzRmZmVxYnY2aGh6ZTYzb2R5Mmd4d29xNDI2ZXJyczg4aGlkZWszYSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/33F5USzk3gJdZTinpS/giphy.gif" alt="A man in nature taking in a deep breath of clean, fresh air" className="w-3/2 rounded-lg shadow-md" data-id="element-141" />
      </div>
      <div className="text-center" data-id="element-142">
        <p className="mb-4 text-lg text-blue-800 text-center" data-id="element-143">
          See if DNRx Works in Your Room
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" className="inline-flex items-center px-8 py-4 text-xl font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition-colors" data-id="element-144">
          <span className="mr-2" data-id="element-145">Check Stock</span>
          <ArrowRightIcon size={20} data-id="element-146" />
        </a>
      </div>
      <div className="mt-12" data-id="element-147">
        <h2 className="text-2xl font-bold mb-6 text-blue-900 text-center" data-id="element-148">
          DNRx vs. Traditional "Solutions"
        </h2>
        <div className="overflow-x-auto" data-id="element-149">
          <table className="w-full text-lg mb-8" data-id="element-150">
            <thead data-id="element-151">
              <tr data-id="element-152">
                <th className="text-left p-3 bg-blue-100" data-id="element-153">Petssey DNRx</th>
                <th className="text-left p-3 bg-blue-100" data-id="element-154">
                  Other Purifiers & Fixes
                </th>
              </tr>
            </thead>
            <tbody data-id="element-155">
              <tr data-id="element-156">
                <td className="border p-3 bg-green-50" data-id="element-157">
                  <div className="flex items-start" data-id="element-158">
    <span className="mr-2" data-id="element-159">✅</span>
    <span data-id="element-160">Compact, plugs into any wall</span>
  </div>
                </td>
                <td className="border p-3 bg-red-50" data-id="element-161">
                <div className="flex items-start" data-id="element-162"> 
                <span className="mr-2" data-id="element-163">❌</span>
                <span data-id="element-164">Bulky machines that dominate a room</span>
                </div>
                </td>
              </tr>
              <tr data-id="element-165">
                <td className="border p-3 bg-green-50" data-id="element-166">
                  <div className="flex items-start" data-id="element-167">
    <span className="mr-2" data-id="element-168">✅</span>
    <span data-id="element-169">Silent 24/7 protection</span>
  </div>
                </td>
                <td className="border p-3 bg-red-50" data-id="element-170">
                <div className="flex items-start" data-id="element-171"> 
                <span className="mr-2" data-id="element-172">❌</span>
                <span data-id="element-173">Loud, disruptive “jet engine” noise</span>
                </div>
                </td>
              </tr>
              <tr data-id="element-174">
                <td className="border p-3 bg-green-50" data-id="element-175">
                  <div className="flex items-start" data-id="element-176">
    <span className="mr-2" data-id="element-177">✅</span>
    <span data-id="element-178">Targets microscopic dander HEPA can miss</span>
  </div>
                </td>
                <td className="border p-3 bg-red-50" data-id="element-179">
                <div className="flex items-start" data-id="element-180"> 
                <span className="mr-2" data-id="element-181">❌</span>
                <span data-id="element-182">Misses the tiniest particles floating in the air</span>
                </div>
                </td>
              </tr>
              <tr data-id="element-183">
                <td className="border p-3 bg-green-50" data-id="element-184">
                  <div className="flex items-start" data-id="element-185">
    <span className="mr-2" data-id="element-186">✅</span>
    <span data-id="element-187">Zero filter costs, ever</span>
  </div>
                </td>
                <td className="border p-3 bg-red-50" data-id="element-188">
                <div className="flex items-start" data-id="element-189"> 
                <span className="mr-2" data-id="element-190">❌</span>
                <span data-id="element-191">$150+ every 6 months on filters</span>
                </div>
                </td>
              </tr>
              <tr data-id="element-192">
                <td className="border p-3 bg-green-50" data-id="element-193">
                  <div className="flex items-start" data-id="element-194">
    <span className="mr-2" data-id="element-195">✅</span>
    <span data-id="element-196">Certified ozone-safe</span>
  </div>
                </td>
                <td className="border p-3 bg-red-50" data-id="element-197">
                <div className="flex items-start" data-id="element-198"> 
                <span className="mr-2" data-id="element-199">❌</span>
                <span data-id="element-200">Older ionisers risk unsafe ozone levels</span>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <blockquote className="border-l-4 border-blue-500 italic pl-4 text-xl mb-8" data-id="element-201">
          "I wish someone had told me about the filter scam sooner. With DNRx,
          you plug it in once and forget it."
          <footer className="text-lg font-medium mt-2" data-id="element-202">— Margaret</footer>
        </blockquote>
        <div className="bg-yellow-50 p-6 rounded-lg mb-8" data-id="element-203">
          <h3 className="text-xl font-semibold mb-4 text-yellow-800" data-id="element-204">
            Why Big Purifier Companies Hate This
          </h3>
          <p className="text-lg mb-4" data-id="element-205">
            Here’s the dirty secret: traditional purifier companies don’t make their money 
            from selling machines. They make it from locking you into a lifetime of filter subscriptions.
          </p>
          <p className="text-lg mb-4" data-id="element-206">Every filter change is another payday for them - not for you</p>
          <p className="text-lg mb-4" data-id="element-207">That’s why they’ll never tell you about a plug-in device that:</p>
          <ul className="list-disc pl-6 text-lg space-y-2" data-id="element-208">
            <li data-id="element-209">Runs silently in the background</li>
            <li data-id="element-210">Never needs replacement filters</li>
            <li data-id="element-211">Costs a fraction of their bulky towers</li>
          </ul>
          <br data-id="element-212"> 
          </br>
          <p className="text-lg mb-4" data-id="element-213">Because if every cat owner switched to Petssey DNRx, 
          the multi-billion-dollar filter business would collapse overnight.</p>
        </div>
      </div>
      <div className="flex justify-center mb-8" data-id="element-214"></div>
      <div className="text-center" data-id="element-215">
        <p className="mb-4 text-lg text-blue-800 text-center" data-id="element-216">
          Breath Freely Without Filters
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" className="inline-flex items-center px-8 py-4 text-xl font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition-colors" data-id="element-217">
          <span className="mr-2" data-id="element-218">Apply Discount</span>
          <ArrowRightIcon size={20} data-id="element-219" />
        </a>
      </div>
    </section>;
}